<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       role="presentation"
       viewBox="0 0 100 100"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" d="m23 21c-7.7578 0-14 6.2422-14 14v30c0 7.7578 6.2422 14 14 14h54c7.7578 0 14-6.2422 14-14v-30c0-7.7578-6.2422-14-14-14zm20 16 22 13-22 13z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>